import React, { useEffect, useState } from "react";
import * as ExpeditioProcessService from "../../../../services/expeditionProcessService";
import PaginateList from "../../../utils/PaginateList";
import {
  PROCESS_EXPEDITION_STATUS,
  PROCESS_INVENTARY_STATUS,
  STOCK_STATUS,
} from "../../../../constants/index";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import { getDateFormatTimeZone } from "../../../../utils/formats";
import { ButtonAction, Icon } from "./expeditionProcessList.styled";
import moment from "moment-timezone";
import PATHS from "../../../../constants/paths";

const ExpeditionProcessListContainer = ({
  filters,
  sortBy,
  refresh,
  onRefreshComplete,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const [data, setData] = useState(null);

  const goToDetail = (uuid) => {
    navigate(PATHS.EXPEDITION_DETAIL.replace(":uuid", uuid));
  };

  useEffect(() => {
    if (refresh) {
      setForceRefresh(true);
    }
  }, [refresh]);

  const columns = [
    {
      header: t("forms.expeditionProcess.table.heads.dateInit"),
      accessorKey: "dateInit",
      cell: (info) => moment(info.getValue()).format("DD-MM-yyyy"),
      size: 200,
    },
    {
      header: t("forms.expeditionProcess.table.heads.article"),
      accessorKey: "article",
      cell: (info) => info.getValue(),
      size: 200,
    },
    // {
    //   header: t("forms.expeditionProcess.table.heads.code"),
    //   accessorKey: "code",
    //   cell: (info) => info.getValue(),
    //   size: 200,
    // },
    {
      header: t("forms.expeditionProcess.table.heads.batchOut"),
      accessorKey: "batchOut",
      cell: (info) => info.getValue(),
      size: 200,
    },
    // {
    //   header: t("forms.inventary.table.heads.dateEnd"),
    //   accessorKey: "dateEnd",
    //   cell: (info) => {
    //     const dateFinal = info.getValue();
    //     if (!dateFinal) {
    //       return "-";
    //     } else {
    //       return moment(info.getValue()).format("DD-MM-yyyy");
    //     }
    //   },
    //   size: 200,
    // },
    {
      header: t("forms.expeditionProcess.table.heads.priority"),
      accessorKey: "priority",
      cell: (info) => info.getValue(),
      size: 200,
    },
    {
      header: t("forms.expeditionProcess.table.heads.status"),
      accessorKey: "status",
      cell: (info) => {
        if (info.row.original.status) {
          const cat = PROCESS_EXPEDITION_STATUS.find(
            (c) => c.code === info.row.original.status
          );
          return t(cat.label);
        }
        return "";
      },
    },

    {
      header: t("forms.order.table.head.actions"),
      accessorKey: "",
      cell: (info) => renderAction(info.row.original),
    },
  ];

  const renderAction = (data) => {
    return (
      // <Can do={USER_PERMISSIONS.EDIT_QUALITY}>
      <div className="dropdown text-center">
        <ButtonAction
          onClick={() => goToDetail(data.uuid)}
          title={t("forms.order.labels.edit")}
        >
          <Icon className="fa-solid fa-arrow-right-long"></Icon>
        </ButtonAction>
      </div>
      // </Can>
    );
  };

  const listData = async (filter) => {
    if (sortBy) {
      filter.sort = sortBy;
    } else {
      filter.sort = "-createdAt";
    }
    const result = await ExpeditioProcessService.listFilterExpeditionProcess(
      filter
    );
    setData(result);

    return result;
  };

  const hide = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    hide.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    hide.itemCode = false;
  }
  return (
    <>
      <PaginateList
        refresh={forceRefresh}
        filters={filters}
        columns={columns}
        toList={listData}
        hideColum={hide}
        resize={resize}
        resetRefresh={() => {
          setForceRefresh(false);
          if (onRefreshComplete) {
            onRefreshComplete();
          }
        }}
      ></PaginateList>
    </>
  );
};

export default ExpeditionProcessListContainer;
